import * as authentication from "../../common/actions/authentication";
import * as productQuery from "../actions/productQuery.js";

import Immutable from "seamless-immutable";

const defaultState = () => {
    return Immutable({
        isLoading: false,
        allResaultsLoaded: false,
        resaultCountString: "0",
        filter: {
            searchString: "",
            ReturnTobacco: false,
        },
        resaults: [],
    });
};

/**
 * productQuery reducer
 * @param {Object} state
 * @param {{type: string}} action
 * @return {*}
 */
export default function(state = defaultState(), action) {
    switch(action.type) {
    case productQuery.SET_QUERY_RESAULTS:
        return state.merge({
            resaultCountString: `${action.resaults.length}${state.allResaultsLoaded?"":"+"}`,
            resaults: action.resaults
        });
    case productQuery.ADD_QUERY_RESAULTS:
    {
        const arr = Immutable.asMutable(state.resaults);
        arr.splice(action.startIndex, arr.length-action.startIndex, ...action.resaults);
        return state.merge({
            resaultCountString: `${action.startIndex+action.resaults.length}${state.allResaultsLoaded?"":"+"}`,
            resaults: arr,
        });
    }
    case productQuery.SET_QUERY_PRODUCT_IMAGE_URL:
        return state.merge({
            resaults: Immutable(state.resaults).map(function(obj, index) {
                return (index === action.index) ? {
                    product:{
                        ...obj.product,
                        imageUrl:action.imageUrl,
                    }
                } : obj;
            })
        }, {
            deep: true
        });
    case productQuery.QUERY_IS_LOADING:
        return state.merge({
            isLoading: true,
        });
    case productQuery.QUERY_DONE_LOADING:
    case productQuery.QUERY_FAILED_LOADING:
        return state.merge({
            isLoading: false,
        });
    case productQuery.QUERY_ALL_RESAULTS_LOADED:
        return state.merge({
            allResaultsLoaded: true,
            resaultCountString: state.resaults.length.toString(),
        });
    case productQuery.EDIT_QUERY_FILTER:
        return state.merge({
            allResaultsLoaded: false,
            resaultCountString: "0",
            filter:{
                ...action.change
            },
            resaults: []
        }, {
            deep: true
        });
    case productQuery.CLEAR_QUERY_RESAULTS:
        return state.merge({
            resaults: []
        }, {
            deep: true
        });
    case productQuery.SET_QUERY_OPTION:
        return state.merge({
            productGroups: action.productGroups,
            productSuppliers: action.productSuppliers,
        }, {
            deep: true
        });
    case authentication.LOGGED_OUT:
        return defaultState();
    default:
        return state;
    }
}